var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 635.175781 174.910156 C 503.546875 43.296875 292.902344 40.566406 164.660156 168.808594 C 52.027344 281.441406 40.449219 457.644531 128.453125 588.027344 L 68.429688 750.296875 L 225.273438 683.777344 C 355.347656 769.449219 529.578125 757.125 641.277344 645.425781 C 769.515625 517.179688 766.785156 306.535156 635.175781 174.910156 Z M 635.175781 174.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#75cd1f",
    d: "M 561.792969 483.585938 C 592.609375 502.144531 598.625 500.761719 598.625 519.566406 C 598.625 536.746094 558.441406 592.378906 512.96875 592.414062 C 446.394531 592.378906 373.664062 551.417969 316.5625 495.871094 C 261.015625 438.769531 220.054688 366.039062 220.019531 299.464844 C 220.019531 253.960938 275.6875 213.8125 292.867188 213.8125 C 311.671875 213.8125 310.289062 219.824219 328.851562 250.640625 C 339.1875 267.785156 363.710938 300.019531 359.0625 312.046875 C 352.40625 329.175781 312.101562 349.308594 312.101562 361.582031 C 312.136719 402.492188 409.941406 500.296875 450.851562 500.328125 C 463.085938 500.296875 483.222656 459.972656 500.382812 453.371094 C 512.414062 448.722656 544.648438 473.246094 561.792969 483.585938 Z M 561.792969 483.585938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIconWhite);
export default __webpack_public_path__ + "static/media/whatsapp-icon-white.fd32df25d8676bb5d4fc0f226ec28b6a.svg";
export { ForwardRef as ReactComponent };